/**
 * Central contact / legal constants used by the Privacy Policy (/privacy) and
 * the Data Deletion request page (/delete).
 *
 * ⚠️ REVIEW BEFORE PUBLISHING TO GOOGLE PLAY.
 * Google Play requires the privacy policy to name the developer and provide a
 * working contact method. The values marked TODO below are placeholders taken
 * from the existing site footer and must be replaced with real details.
 */
export const LEGAL = {
  brand: 'Event Story',

  // TODO: registered legal/business name, if different from the brand.
  legalEntity: 'Event Story',

  // Public site. Used to build the canonical policy URLs shown to Play.
  website: 'https://eventstory4u.com',

  // TODO: confirm — taken from the site footer.
  contactEmail: 'hello@eventstory4u.com',

  // Business WhatsApp / phone line.
  phone: '+91 9444 150808',

  // TODO: full registered postal address (Play expects a real one).
  address: 'Mumbai, India',

  // Update whenever the policy text materially changes.
  effectiveDate: '20 August 2026',

  // Commitments made in the policy — keep these consistent with what you
  // actually do, and with the Play Console "Data safety" declaration.
  deletionSlaDays: 30,
  retentionMonths: 24,
};

export const PRIVACY_URL = `${LEGAL.website}/privacy`;
export const DELETE_URL = `${LEGAL.website}/delete`;
